const mutations = {
  mutationEndorsement(state, payload) {
    state.endorsement = payload;
  },

  mutationEndorsements(state, payload) {
    if (payload && (payload.tab || payload.tab === 0)) {
      state.endorsements[payload.tab] = payload.responseData;
    } else {
      state.endorsements = payload;
    }
  },

  mutationEndorsementsMeta(state, payload) {
    state.endorsementsMeta = payload;
  },

  mutationPartners(state, payload) {
    state.partners = payload;
  },

  mutationProductCategories(state, payload) {
    state.productCategories = payload;
  },
};

export default mutations;
